import { FC, ReactNode, useMemo } from "react";
import { RvStatus } from "../constants";
import { Label } from "./SelectPayment";
import { RvStatusType } from "../types";
import { CheckCircleBroken } from "untitledui-js-base";

type Props = {
  status: RvStatusType;
};

export const RvStatusBadge: FC<Props> = ({ status }) => {
  const {
    icon,
    title
  }: {
    icon?: ReactNode;
    title?: ReactNode;
  } = useMemo(() => {
    switch (status.status) {
      case RvStatus.ManualVerificationNeeded:
        return {
          title: "No data",
          icon: <div className="border border-content-100 w-4" />
        };
      case RvStatus.Verified:
      case RvStatus.PendingConfirmation:
        if (status.months_delinquency === 0)
          return {
            title: (
              <p className="text-xs font-medium text-success-700">
                Paid on-time
              </p>
            ),
            icon: <CheckCircleBroken size="16" className="stroke-success-700" />
          };
        else
          return {
            title: (
              <p className="text-xs font-medium text-danger-700">
                {status.months_delinquency} + months late
              </p>
            ),
            icon: (
              <div className="bg-danger-50 h-5 w-5 flex items-center justify-center rounded">
                <p className="text-danger-500 text-sm font-bold">
                  {status.months_delinquency}
                </p>
              </div>
            )
          };

      default:
        return {
          title: "No data",
          icon: <div className="border border-content-100 w-4" />
        };
    }
  }, [status]);

  return <Label title={title} icon={icon} />;
};
